module.exports = __webpack_public_path__ + "static/media/realEstateForecasting.90de1cb2.webp";